export function GfeSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/gfe.svg'"></ng-include>`
    }
}
            